export default "__VITE_ASSET__DcPBncN1__"